import { createContext, useMemo, useState } from 'react';
type CoursesContextType = {
  courses: any;
  setCourses: React.Dispatch<React.SetStateAction<any>>;
  selectedCourseData: any;
  setSelectedCourseData: React.Dispatch<React.SetStateAction<any>>;
};
const coursesState = {
  courses: [],
  setCourses: () => null,
  selectedCourseData: null,
  setSelectedCourseData: () => null
};
export const CourseContext = createContext<CoursesContextType>(coursesState);
const CourseContextProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [courses, setCourses] = useState<any>(null);
  const [selectedCourseData, setSelectedCourseData] = useState<any>(null);
  const coursesStore = useMemo(() => {
    return {
      courses,
      setCourses,
      selectedCourseData,
      setSelectedCourseData
    };
  }, [courses, selectedCourseData]);
  return <CourseContext.Provider value={coursesStore} data-sentry-element="unknown" data-sentry-component="CourseContextProvider" data-sentry-source-file="CoursesContextProvider.tsx">{children}</CourseContext.Provider>;
};
export default CourseContextProvider;